import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface Question {
    idQuestion: string;
    type: string;
    question: string;
    A: string;
    B: string;
    C: string;
    D: string;
    E?: string;
    correct: string;
}

interface ResultsViewProps {
    questions: Question[];
    answers: { [key: string]: string };
    score: number;
    totalQuestions: number;
    onClose: () => void;
}

const ResultsView: React.FC<ResultsViewProps> = ({ questions, answers, score, totalQuestions, onClose }) => {
    const getCorrectAnswerContent = (question: Question) => {
        return question[question.correct as keyof Question];
    };

    return (
        <>
            <Typography variant="h6" sx={{ textAlign: 'center', mb: 2 }}>
                Você acertou {score} de {totalQuestions}
            </Typography>
            <Box>
                {questions.map((question, index) => {
                    const userAnswer = answers[question.idQuestion];
                    const isCorrect = userAnswer === question.correct;
                    return (
                        <Box key={question.idQuestion} sx={{ mb: 1 }}>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                {index + 1}. {question.question}
                            </Typography>
                            <Typography sx={{ color: isCorrect ? 'success.main' : 'error.main' }}>
                                Sua resposta: {userAnswer || 'Nenhuma'}, Correta: {question.correct} - {getCorrectAnswerContent(question)}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Button variant="contained" onClick={onClose} sx={{ backgroundColor: 'primary.main', color: 'white', margin: '20px' }}>
                    Fechar
                </Button>
            </Box>
        </>
    );
};

export default ResultsView;
